import {Component, Input} from '@angular/core';
import {AbstractFieldComponent} from '../_abstract/abstract-field.component';

@Component({
    selector: 'field-select2-autocomplete',
    templateUrl: './field-select2-autocomplete.component.html',
    styleUrls: [
        './field-select2-autocomplete.component.scss'
    ],
    standalone: false
})
export class FieldSelect2AutocompleteComponent extends AbstractFieldComponent {

  @Input() public caption = '';
  @Input() public placeholder = '';
  @Input() public api_action = '';
  @Input() public value_caption = '';

}
